// src/api/fetch.ts

export const API_BASE_URL = "https://api.dev.saasbase.io/v1";

export class ApiError extends Error {
  status: number;
  data?: unknown;

  constructor(message: string, status: number, data?: unknown) {
    super(message);
    this.name = "ApiError";
    this.status = status;
    this.data = data;
  }
}

export interface RequestOptions extends RequestInit {
  token?: string;
}

export async function apiFetch<T>(
  endpoint: string,
  options: RequestOptions = {},
): Promise<T> {
  const { token, headers, ...rest } = options;

  const response = await fetch(`${API_BASE_URL}${endpoint}`, {
    ...rest,
    headers: {
      "Content-Type": "application/json",
      ...(token && {
        Authorization: `Bearer ${token}`,
      }),
      ...headers,
    },
  });

  let data: any = null;

  try {
    data = await response.json();
  } catch {
    // ignore non-json responses
  }

  if (!response.ok) {
    throw new ApiError(
      data?.error?.message || response.statusText || "Something went wrong",
      response.status,
      data,
    );
  }

  return data as T;
}
